(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arienvo-moments-wall"] && !Shopify.designMode) return;
  try {
    
  class ArienvoMomentsWall {
    constructor(root) {
      this.root = root;
      this.stage = root.querySelector('[data-awm-stage]');
      this.dialog = root.querySelector('[data-awm-dialog]');
      this.flipCard = root.querySelector('[data-awm-flip-card]');
      this.frontFace = root.querySelector('[data-awm-front]');
      this.backFace = root.querySelector('[data-awm-back]');
      this.modalImage = root.querySelector('[data-awm-modal-image]');
      this.modalTitle = root.querySelector('[data-awm-modal-title]');
      this.modalAuthor = root.querySelector('[data-awm-modal-author]');
      this.modalStory = root.querySelector('[data-awm-modal-story]');
      this.center = root.querySelector('.awm-center');
      this.creatorDialog = root.querySelector('[data-awm-creator-dialog]');
      this.creatorCard = root.querySelector('[data-awm-creator-card]');
      this.creatorFront = root.querySelector('[data-awm-creator-front]');
      this.creatorBack = root.querySelector('[data-awm-creator-back]');
      this.creatorForm = root.querySelector('[data-awm-creator-form]');
      this.creatorStatus = root.querySelector('[data-awm-creator-status]');
      this.submissionNotices = root.querySelectorAll('[data-awm-submission-notice]');
      this.submissionClosedCopies = root.querySelectorAll('[data-awm-submission-closed]');
      this.shareButton = root.querySelector('[data-awm-share]');
      this.creatorSuccess = root.querySelector('[data-awm-creator-success]');
      this.photoInput = root.querySelector('[data-awm-photo-input]');
      this.photoPreview = root.querySelector('[data-awm-photo-preview]');
      this.uploadFrame = root.querySelector('[data-awm-upload-frame]');
      this.creatorObjectUrl = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.isFirewall = root.dataset.awmLayout === 'firewall';
      this.orbitStates = [];
      this.animationFrame = null;
      this.lastFrameTime = null;
      this.isInView = true;
      this.isTransitioning = false;
      this.lastTrigger = null;
      this.selectedOrbit = null;
      this.closeTimer = null;
      this.submissionsEnabled = false;
      this.submissionStatusState = 'checking';
      this.submissionStatusPromise = null;
      this.qaSession = null;
      this.internalQa = false;

      if (!this.stage || !this.dialog || !this.flipCard) return;

      this.setupOrbits();
      this.bindEvents();
      this.renderOrbits();
      this.updateOrbitActivity();
      root.dataset.awmReady = 'true';
      this.consumeQaFragment();
    }

    setupOrbits() {
      this.orbitStates = [...this.root.querySelectorAll('[data-awm-orbit]')].map((orbit) => {
        const styles = getComputedStyle(orbit);
        const state = {
          orbit,
          angle: this.numberFromProperty(styles, '--awm-phase') * (Math.PI / 180),
          radiusX: 0,
          radiusY: 0,
          duration: 70,
          direction: this.numberFromProperty(styles, '--awm-direction') || 1,
          pointerPaused: false,
          focusPaused: false,
        };

        orbit.addEventListener('pointerenter', () => {
          state.pointerPaused = true;
        });
        orbit.addEventListener('pointerleave', () => {
          state.pointerPaused = false;
        });
        orbit.addEventListener('focusin', () => {
          state.focusPaused = true;
        });
        orbit.addEventListener('focusout', () => {
          window.setTimeout(() => {
            state.focusPaused = orbit.contains(document.activeElement);
          });
        });

        return state;
      });

      this.syncOrbitMetrics();

      this.resizeObserver = new ResizeObserver(() => {
        this.syncOrbitMetrics();
        this.renderOrbits();
      });
      this.resizeObserver.observe(this.stage);

      this.intersectionObserver = new IntersectionObserver(
        ([entry]) => {
          this.isInView = entry.isIntersecting;
          this.updateOrbitActivity();
        },
        { threshold: 0.04 }
      );
      this.intersectionObserver.observe(this.root);

      document.addEventListener('visibilitychange', () => this.updateOrbitActivity());
      this.motionQuery.addEventListener?.('change', () => this.updateOrbitActivity());
    }

    numberFromProperty(styles, property) {
      return Number.parseFloat(styles.getPropertyValue(property)) || 0;
    }

    syncOrbitMetrics() {
      const stageWidth = this.stage.clientWidth;
      const stageHeight = this.stage.clientHeight;

      this.orbitStates.forEach((state) => {
        const styles = getComputedStyle(state.orbit);
        state.radiusX = stageWidth * this.numberFromProperty(styles, '--awm-radius-x');
        state.radiusY = stageHeight * this.numberFromProperty(styles, '--awm-radius-y');
        state.duration = Math.max(1, this.numberFromProperty(styles, '--awm-duration'));
        state.direction = this.numberFromProperty(styles, '--awm-direction') || 1;
      });
    }

    renderOrbits() {
      if (this.isFirewall) return;

      this.orbitStates.forEach((state) => {
        const x = Math.cos(state.angle) * state.radiusX;
        const y = Math.sin(state.angle) * state.radiusY;
        state.orbit.style.transform = `translate(-50%, -50%) translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
      });
    }

    updateOrbitActivity() {
      if (this.isFirewall) return;

      const shouldRun = this.isInView && !document.hidden && !this.motionQuery.matches;

      if (shouldRun && this.animationFrame === null) {
        this.lastFrameTime = null;
        this.animationFrame = requestAnimationFrame((time) => this.tick(time));
      }

      if (!shouldRun && this.animationFrame !== null) {
        cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.lastFrameTime = null;
      }
    }

    tick(time) {
      if (this.lastFrameTime === null) this.lastFrameTime = time;
      const elapsed = Math.min((time - this.lastFrameTime) / 1000, 0.05);
      this.lastFrameTime = time;

      if (!this.stage.classList.contains('is-orbit-paused')) {
        this.orbitStates.forEach((state) => {
          if (state.pointerPaused || state.focusPaused) return;
          state.angle += state.direction * elapsed * ((Math.PI * 2) / state.duration);
        });
        this.renderOrbits();
      }

      this.animationFrame = requestAnimationFrame((nextTime) => this.tick(nextTime));
    }

    bindEvents() {
      this.root.querySelectorAll('[data-awm-card]').forEach((card) => {
        card.addEventListener('click', () => this.open(card));
      });

      this.root.querySelector('[data-awm-close]')?.addEventListener('click', () => this.close());
      this.root.querySelector('[data-awm-show-story]')?.addEventListener('click', () => this.showStory());
      this.root.querySelector('[data-awm-show-photo]')?.addEventListener('click', () => this.showPhoto());

      this.root.querySelector('[data-awm-create]')?.addEventListener('click', () => this.openCreator());
      this.root.querySelector('[data-awm-creator-close]')?.addEventListener('click', () => this.closeCreator());
      this.root.querySelector('[data-awm-creator-next]')?.addEventListener('click', () => this.showCreatorStory());
      this.root.querySelector('[data-awm-creator-back-button]')?.addEventListener('click', () => this.showCreatorPhoto());
      this.root.querySelector('[data-awm-creator-done]')?.addEventListener('click', () => this.closeCreator());
      this.photoInput?.addEventListener('change', () => this.previewCreatorPhoto());
      this.creatorForm?.addEventListener('submit', (event) => this.submitCreator(event));

      this.creatorDialog?.addEventListener('click', (event) => {
        if (event.target === this.creatorDialog) this.closeCreator();
      });
      this.creatorDialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeCreator();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
    }

    async open(card) {
      if (this.isTransitioning || this.dialog.open) return;

      this.isTransitioning = true;
      this.lastTrigger = card;
      this.selectedOrbit = card.closest('[data-awm-orbit]');
      this.stage.classList.add('is-orbit-paused');
      this.selectedOrbit?.classList.add('is-selected');
      this.showPhoto();
      this.populateDialog(card);

      await this.flyCardToCenter(card);

      this.dialog.classList.remove('is-closing');
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      this.isTransitioning = false;
      this.root.querySelector('[data-awm-show-story]')?.focus({ preventScroll: true });
    }

    populateDialog(card) {
      const title = card.querySelector('[data-awm-title]')?.textContent.trim() || '';
      const author = card.querySelector('[data-awm-author]')?.textContent.trim() || '';
      const story = card.querySelector('[data-awm-story]')?.textContent.trim() || '';
      const cardImage = card.querySelector('img');

      this.modalImage.src = card.dataset.imageLarge || cardImage?.currentSrc || cardImage?.src || '';
      this.modalImage.alt = cardImage?.alt || title;
      this.modalTitle.textContent = title;
      this.modalAuthor.textContent = author;
      this.modalStory.textContent = story;
    }

    async flyCardToCenter(card) {
      if (this.motionQuery.matches || typeof card.animate !== 'function') return;

      const rect = card.getBoundingClientRect();
      const flight = card.cloneNode(true);
      const initialTransform = getComputedStyle(card).transform;
      const targetWidth = Math.min(window.innerWidth * 0.72, window.innerHeight * 0.48, 390);
      const scale = Math.max(1.12, targetWidth / rect.width);
      const moveX = window.innerWidth / 2 - (rect.left + rect.width / 2);
      const moveY = window.innerHeight / 2 - (rect.top + rect.height / 2);

      flight.removeAttribute('data-awm-card');
      flight.removeAttribute('aria-controls');
      flight.removeAttribute('aria-haspopup');
      flight.setAttribute('aria-hidden', 'true');
      flight.setAttribute('tabindex', '-1');
      flight.classList.add('awm-flight-card');
      flight.style.left = `${rect.left}px`;
      flight.style.top = `${rect.top}px`;
      flight.style.width = `${rect.width}px`;
      flight.style.height = `${rect.height}px`;
      flight.style.setProperty('--awm-card-width', `${rect.width}px`);
      flight.style.setProperty('--awm-card-rotation', '0deg');
      document.body.appendChild(flight);

      const animation = flight.animate(
        [
          { transform: initialTransform, opacity: 1, filter: 'blur(0)' },
          {
            offset: 0.78,
            transform: `translate3d(${moveX}px, ${moveY}px, 0) scale(${scale * 0.98}) rotate(0deg)`,
            opacity: 1,
            filter: 'blur(0)',
          },
          {
            transform: `translate3d(${moveX}px, ${moveY}px, 0) scale(${scale}) rotate(0deg)`,
            opacity: 0,
            filter: 'blur(3px)',
          },
        ],
        {
          duration: 760,
          easing: 'cubic-bezier(0.2, 0.78, 0.2, 1)',
          fill: 'forwards',
        }
      );

      await animation.finished.catch(() => {});
      flight.remove();
    }

    close() {
      if (!this.dialog.open || this.isTransitioning) return;

      this.dialog.classList.add('is-closing');
      this.closeTimer = window.setTimeout(() => {
        this.dialog.classList.remove('is-closing');
        this.dialog.close();
        this.showPhoto();
        this.modalImage.removeAttribute('src');
        this.selectedOrbit?.classList.remove('is-selected');
        this.stage.classList.remove('is-orbit-paused');
        this.lastTrigger?.focus({ preventScroll: true });
        this.selectedOrbit = null;
      }, 220);
    }

    showStory() {
      this.flipCard.classList.add('is-flipped');
      this.frontFace?.setAttribute('inert', '');
      this.backFace?.removeAttribute('inert');
      window.setTimeout(() => {
        this.root.querySelector('[data-awm-show-photo]')?.focus({ preventScroll: true });
      }, 420);
    }

    showPhoto() {
      this.flipCard.classList.remove('is-flipped');
      this.backFace?.setAttribute('inert', '');
      this.frontFace?.removeAttribute('inert');
    }

    openCreator() {
      if (!this.creatorDialog || this.dialog.open || this.isTransitioning || this.stage.classList.contains('is-creator-open')) return;
      void this.refreshSubmissionStatus();
      this.stage.classList.add('is-orbit-paused', 'is-creator-open');
      this.orbitStates.forEach((state) => state.orbit.querySelector('.awm-orbit__frame')?.style.setProperty('opacity', '0.5'));
      this.center?.classList.add('is-creating');
      this.creatorCard?.classList.remove('is-flipped');
      this.creatorSuccess?.setAttribute('hidden', '');
      this.creatorCard?.removeAttribute('hidden');
      this.showCreatorPhoto();
      window.setTimeout(() => {
        if (!this.stage.classList.contains('is-creator-open')) return;
        if (typeof this.creatorDialog.showModal === 'function') this.creatorDialog.showModal();
        else this.creatorDialog.setAttribute('open', '');
        window.setTimeout(() => this.photoInput?.focus({ preventScroll: true }), 80);
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 380);
    }

    closeCreator() {
      if (!this.creatorDialog) return;
      if (this.creatorDialog.open && typeof this.creatorDialog.close === 'function') this.creatorDialog.close();
      else this.creatorDialog.removeAttribute('open');
      this.stage.classList.remove('is-orbit-paused', 'is-creator-open');
      this.orbitStates.forEach((state) => state.orbit.querySelector('.awm-orbit__frame')?.style.removeProperty('opacity'));
      this.center?.classList.remove('is-creating');
      this.creatorCard?.classList.remove('is-flipped');
      this.creatorForm?.reset();
      this.creatorStatus.textContent = '';
      this.creatorSuccess?.setAttribute('hidden', '');
      this.creatorCard?.removeAttribute('hidden');
      this.uploadFrame?.classList.remove('has-preview');
      if (this.creatorObjectUrl) URL.revokeObjectURL(this.creatorObjectUrl);
      this.creatorObjectUrl = null;
      if (this.photoPreview) this.photoPreview.style.backgroundImage = '';
    }

    showCreatorStory() {
      if (!this.photoInput?.files?.[0]) {
        this.creatorStatus.textContent = 'Please add a photo first.';
        this.photoInput?.focus();
        return;
      }
      this.creatorCard?.classList.add('is-flipped');
      this.creatorFront?.setAttribute('inert', '');
      this.creatorBack?.removeAttribute('inert');
      window.setTimeout(() => this.creatorBack?.querySelector('textarea')?.focus({ preventScroll: true }), 420);
    }

    showCreatorPhoto() {
      this.creatorCard?.classList.remove('is-flipped');
      this.creatorBack?.setAttribute('inert', '');
      this.creatorFront?.removeAttribute('inert');
    }

    previewCreatorPhoto() {
      const file = this.photoInput?.files?.[0];
      if (!file) return;
      if (this.creatorObjectUrl) URL.revokeObjectURL(this.creatorObjectUrl);
      this.creatorObjectUrl = URL.createObjectURL(file);
      this.photoPreview.style.backgroundImage = `url("${this.creatorObjectUrl}")`;
      this.uploadFrame?.classList.add('has-preview');
      this.creatorStatus.textContent = '';
    }

    consumeQaFragment() {
      const fragment = window.location.hash;
      if (!fragment.startsWith('#arienvo-qa=')) {
        void this.refreshSubmissionStatus();
        return;
      }
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      const code = fragment.slice('#arienvo-qa='.length);
      if (!/^[0-9a-f]{64}$/.test(code)) {
        void this.refreshSubmissionStatus();
        return;
      }
      void this.redeemQaCode(code);
    }

    async redeemQaCode(code) {
      this.submissionStatusState = 'checking';
      this.updateSubmissionAvailability();
      try {
        const response = await fetch('/apps/arienvo-moments/qa/redeem', { method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ code }) });
        const body = await response.json();
        if (response.ok && body.ok === true && /^[0-9a-f]{64}$/.test(body.session)) this.qaSession = body.session;
      } catch {
        this.qaSession = null;
      }
      if (this.submissionStatusPromise) await this.submissionStatusPromise;
      await this.refreshSubmissionStatus();
    }

    refreshSubmissionStatus() {
      if (this.submissionStatusPromise) return this.submissionStatusPromise;
      this.submissionStatusState = 'checking';
      this.submissionsEnabled = false;
      this.updateSubmissionAvailability();
      const request = (async () => {
        let enabled = false;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const qa = Boolean(this.qaSession);
          const response = await fetch(qa ? '/apps/arienvo-moments/qa/status' : '/apps/arienvo-moments/status', qa
            ? { method: 'POST', credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ session: this.qaSession }), signal: controller.signal }
            : { method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
          const body = await response.json();
          enabled = response.ok && body.ok === true && body.submissionsEnabled === true;
          this.internalQa = enabled && body.internalQa === true;
          if (qa && !this.internalQa) this.qaSession = null;
        } catch {
          enabled = false;
          this.internalQa = false;
        } finally {
          clearTimeout(timeout);
        }
        this.submissionsEnabled = enabled;
        this.submissionStatusState = enabled ? 'enabled' : 'disabled';
        this.updateSubmissionAvailability();
        return enabled;
      })();
      this.submissionStatusPromise = request.finally(() => { this.submissionStatusPromise = null; });
      return this.submissionStatusPromise;
    }

    updateSubmissionAvailability() {
      this.submissionNotices.forEach((notice) => {
        notice.hidden = this.submissionStatusState === 'enabled' && !this.internalQa;
        notice.textContent = this.submissionStatusState === 'checking' ? 'CHECKING SUBMISSION AVAILABILITY' : this.internalQa ? 'INTERNAL QA MODE' : 'SUBMISSIONS ARE COMING SOON';
      });
      this.submissionClosedCopies.forEach((copy) => {
        copy.hidden = this.submissionStatusState !== 'disabled' || this.internalQa;
      });
      if (this.shareButton) this.shareButton.disabled = this.submissionStatusState !== 'enabled';
    }

    async submitCreator(event) {
      event.preventDefault();
      if (!this.submissionsEnabled || !(await this.refreshSubmissionStatus())) {
        this.creatorStatus.textContent = 'SUBMISSIONS ARE COMING SOON';
        return;
      }
      if (!this.creatorForm || !this.photoInput?.files?.[0]) return;
      if (!this.creatorForm.checkValidity()) {
        this.creatorForm.reportValidity();
        return;
      }
      const submitButton = this.shareButton;
      submitButton.disabled = true;
      this.creatorStatus.textContent = 'Sending your memory…';
      const data = new FormData(this.creatorForm);
      data.set('photo', this.photoInput.files[0]);
      data.set('idempotency_key', crypto.randomUUID());
      if (this.qaSession && this.internalQa) {
        data.set('title', 'QA STOREFRONT SUBMISSION');
        data.set('qa_session', this.qaSession);
      }
      try {
        const response = await fetch('/apps/arienvo-moments/submit', { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) {
          const enabled = await this.refreshSubmissionStatus();
          this.creatorStatus.textContent = !enabled || body.code === 'SUBMISSIONS_DISABLED' ? 'SUBMISSIONS ARE COMING SOON' : (body.message || 'We could not receive this memory. Please try again.');
          return;
        }
        this.creatorCard?.setAttribute('hidden', '');
        this.creatorSuccess?.removeAttribute('hidden');
        this.qaSession = null;
        this.internalQa = false;
        this.submissionsEnabled = false;
        this.submissionStatusState = 'disabled';
        this.updateSubmissionAvailability();
      } catch {
        this.creatorStatus.textContent = 'We could not receive this memory. Please try again.';
      } finally {
        submitButton.disabled = !this.submissionsEnabled;
      }
    }
  }

  const initializeArienvoMomentsWalls = (scope = document) => {
    scope.querySelectorAll('[data-arienvo-moments-wall]:not([data-awm-ready])').forEach((root) => {
      new ArienvoMomentsWall(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeArienvoMomentsWalls(), { once: true });
  } else {
    initializeArienvoMomentsWalls();
  }

  document.addEventListener('shopify:section:load', (event) => initializeArienvoMomentsWalls(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arienvo-share-moment"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-share-moment]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-share-form]');
    const key = root.querySelector('[data-idempotency-key]');
    const input = root.querySelector('[data-photo-input]');
    const preview = root.querySelector('[data-photo-preview]');
    const status = root.querySelector('[data-form-status]');
    const button = root.querySelector('[data-submit]');
    if (!form || !key || !input || !preview || !status || !button) return;
    key.value = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    input.addEventListener('change', () => { const file = input.files?.[0]; if (!file) { preview.hidden = true; return; } preview.src = URL.createObjectURL(file); preview.hidden = false; });
    form.addEventListener('submit', (event) => { event.preventDefault(); status.textContent = 'Submissions are coming soon. Please keep your moment close — we will open the archive shortly.'; status.hidden = false; button.setAttribute('aria-disabled', 'true'); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
